// Import Axios and other dependencies
import axios from 'axios';
//import router from '../router'; // Assuming you have a router instance

// Create Axios instance with base URL and other configurations
const api = axios.create({
  baseURL: getApiUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    withCredentials: true
    // Add other headers as needed
  }
});

// Response interceptor to handle token expiration and refresh
// api.interceptors.response.use(
//   (response) => {
//     // Do something with the response data
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // Check if the error is due to unauthorized access
//     if (
//       error.response &&
//       error.response.status === 401 &&
//       !originalRequest._retry &&
//       originalRequest.url !== '/user/login'
//     ) {
//       originalRequest._retry = true;

//       // Login as guest account
//       try {
//         await loginGuestAccount();

//         // Retry the original request with the new token
//         return api(originalRequest);
//       } catch (guestLoginError) {
//         // Handle refresh error or redirect to login
//         router.push('/error');
//         return Promise.reject(guestLoginError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// async function loginGuestAccount() {
//   const response = await api.post('/user/loginGuest');
//   return response;
// }

function getApiUrl() {
  if (
    window.location.host.indexOf('dev') >= 0 ||
    window.location.host.indexOf('localhost') >= 0
  ) {
    return 'https://devapi.sigflo.com/api';
  } else {
    return 'https://api.sigflo.com/api';
  }
}

export default api;
